import { render, staticRenderFns } from "./marketingCenter.vue?vue&type=template&id=557347c4&scoped=true&lang=pug"
import script from "./marketingCenter.vue?vue&type=script&lang=js"
export * from "./marketingCenter.vue?vue&type=script&lang=js"
import style0 from "./marketingCenter.vue?vue&type=style&index=0&id=557347c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557347c4",
  null
  
)

export default component.exports